import { signOut } from "firebase/auth";
import axios from "axios";
import { auth } from "db/firebase";
import {clearAuthToken, getAuthToken, updateAuthToken} from "../../../helpers/helperFunctions";


export const baseURL = process.env.REACT_APP_BACKEND_URL;


let headers = {'Content-Type': 'application/json'};
const apiService = axios.create({
  baseURL: baseURL,
  headers
});

apiService.interceptors.request.use(config => {
  const authToken = getAuthToken();
  if (authToken.access_token) {
    config.headers.Authorization = `Bearer ${authToken.access_token}`;
  }
  return config;
});


apiService.interceptors.response.use(
  (response) =>
    new Promise((resolve, reject) => {
      if (response && response.data.access_token && response.data.refresh_token) {
        const isAuthorized = response.data.user && response.data.access_token;
        if (isAuthorized) {
          updateAuthToken({
            user: response.data.user,
            "access_token": response.data.access_token,
            "refresh_token": response.data.refresh_token
          });
          resolve(response);
        } else {
          reject({message: "You are not authorized."});
        }

      } else {
        resolve(response);
      }
    }),
  (error) => {
    if (!error.response) {
      return new Promise((resolve, reject) => {
        reject(error);
      });
    }

    if (error.response && error.response.status === 401 && (!error.response.data || (error.response.data &&
      (error.response.data.code !== 4001 && error.response.data.message !== 'User is not Authorized' && error.response.data.message !== 'User is not verified' && error.response.data.message !== 'invalid otp')))) {
      //todo need changes here

      signOut(auth).then();
      clearAuthToken()
      window.location.href = "/login";
    } else {
      return new Promise((resolve, reject) => {
        reject(error);
      });
    }
  }
);

export default apiService;
